import { OrgFilterMenu } from '@/components/OrgFilterMenu/OrgFilterMenu'
import { useTranslation } from 'react-i18next'

interface OrganizationFilterProps {
  selectedValue: string | null
  onSearch: (value: string) => void
}

export function OrganizationFilter({
  selectedValue,
  onSearch,
}: OrganizationFilterProps) {
  const { t } = useTranslation()

  return (
    <OrgFilterMenu
      buttonLabel={t('clusterConfigTable.filters.organization')}
      selectedOrgId={selectedValue}
      onApply={onSearch}
      inputId="cluster-configs-org-filter"
    />
  )
}
